<img class="pmi-logo" src="assets/img/game/pmi-logo.svg">
<div class="alchemist-logo">
  <img class="logo" src="assets/icon/alchemist-logo.svg">
  <div style="font-family: Brandon-Light; white-space: nowrap; font-size: 0.55em; letter-spacing: 0.15em;"><span style="font-weight: bold;">LEARNING</span> TRANSFORMED</div>
</div>
<div class="i-btn i-blue" 
  [ngStyle]="{'background-image': 'url(assets/img/game/i-blue.svg)'}"
  (click)="onDistrictInfoClick('Retail')"
></div>
<div class="i-btn i-orange"
  [ngStyle]="{'background-image': 'url(assets/img/game/i-orange.svg)'}"
  (click)="onDistrictInfoClick('University')"
></div>
<div class="i-btn i-green"
  [ngStyle]="{'background-image': 'url(assets/img/game/i-green.svg)'}"
  (click)="onDistrictInfoClick('Suburban')"
></div>
<div class="i-btn i-red"
  [ngStyle]="{'background-image': 'url(assets/img/game/i-red.svg)'}"
  (click)="onDistrictInfoClick('Shopping Centre')"
></div>
<div class="i-btn i-pink"
  [ngStyle]="{'background-image': 'url(assets/img/game/i-pink.svg)'}"
  (click)="onDistrictInfoClick('Industrial')"
></div>

<ng-container *ngIf="quarter$ | async as quarter">
  <ng-container *ngIf="quarter !== 'q1'">
    <div class="arrow-btn"
      [ngStyle]="{'background-image': 'url(assets/img/game/taerra-arrow.svg)'}"
      (click)="onDistrictClick(0)"
      style="top: 22em; left: 38em"
    ><div class="el"><div>{{ shopNumbers['University'] }}</div></div></div>
    <div class="arrow-btn"
      [ngStyle]="{'background-image': 'url(assets/img/game/taerra-arrow.svg)'}"
      (click)="onDistrictClick(1)"
      style="top: 11em; left: 57em"
    ><div class="el"><div>{{ shopNumbers['Retail'] }}</div></div></div>
    <div class="arrow-btn"
      [ngStyle]="{'background-image': 'url(assets/img/game/taerra-arrow.svg)'}"
      (click)="onDistrictClick(2)"
      style="top: 34em; left: 30em"
    ><div class="el"><div>{{ shopNumbers['Suburban'] }}</div></div></div>
    <div class="arrow-btn"
      [ngStyle]="{'background-image': 'url(assets/img/game/taerra-arrow.svg)'}"
      (click)="onDistrictClick(3)"
      style="top: 24em; left: 71em"
    ><div class="el"><div>{{ shopNumbers['Industrial'] }}</div></div></div>
    <div class="arrow-btn"
      [ngStyle]="{'background-image': 'url(assets/img/game/taerra-arrow.svg)'}"
      (click)="onDistrictClick(4)"
      style="top: 39.5em; left: 57.5em"
    ><div class="el"><div>{{ shopNumbers['Shopping Centre'] }}</div></div></div>
  </ng-container>
</ng-container>

<div class="small-btn-wrap" *ngIf="quarter$ | async as quarter">
  <app-button-bg
    class="small-btn disabled"
    img="/assets/img/game/kpi-btn-bg.svg"
    *ngIf="quarter === 'q1'"
  >
    <div class="small-btn-inside disabled">KPI's</div>
  </app-button-bg>
  <app-button-bg
    class="small-btn disabled"
    img="/assets/img/game/news-btn-bg.svg"
    *ngIf="quarter === 'q1'"
  >
    <div class="small-btn-inside disabled">News</div>
  </app-button-bg>
  <app-button-bg
    class="small-btn"
    img="/assets/img/game/kpi.svg"
    *ngIf="quarter !== 'q1'"
    (click)="onNavigateToKpi()"
  >
    <div class="small-btn-inside">KPI's</div>
  </app-button-bg>
  <app-button-bg
    class="small-btn"
    img="/assets/img/game/news.svg"
    *ngIf="quarter !== 'q1'"
    (click)="onNavigateToNews()"
  >
    <div class="small-btn-inside">News</div>
  </app-button-bg>
</div>

<div class="left-column" *ngIf="quarter$ | async as quarter">
  <div class="text-wrap">
    <img src="assets/img/game/welcome.svg">
    <div class="larger">{{ instructionInitial }}</div>
    <div *ngFor="let additional of instructionAdditional">{{ additional }}</div>
  </div>
  <app-button-bg *ngIf="quarter === 'q1'" class="call-file-btn" img="/assets/img/game/call-file-bg.svg" (click)="onCallFileClick()">
    <div class="btn-inside">Call File</div>
  </app-button-bg>
</div>

<div class="aam-wrap" [ngClass]="quarter === 'q3' ? 'visible' : ''" *ngIf="quarter$ | async as quarter">
  <div class="aam-btn" (click)="onAamClick()" *ngIf="quarter === 'q3'">
    <div class="text">AAM Toolkit</div>
    <div class="img-box"><img src="/assets/img/game/toolkit-white.svg"></div>
  </div>
  <div class="end-quarter-wrap" [ngClass]="!isQuarterFinished() ? 'disabled' : ''">
    <div *ngIf="isQuarterFinished()" class="end-quarter-btn"
      (click)="endQuarter()"
    ><span class="pink">End</span> <span> Quarter</span></div>
    <div *ngIf="!isQuarterFinished()" class="end-quarter-btn disabled"
    ><span class="pink">End</span> <span> Quarter</span></div>
  </div>
</div>